var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.928C9.21615 16.6302 10.5957 16.9999 12 17C13.4044 17.0001 14.784 16.6304 16.0002 15.9283C17.2164 15.2262 18.2263 14.2163 18.9285 13.0001C19.6307 11.7839 20.0004 10.4043 20.0004 9C20.0004 7.59567 19.6307 6.21609 18.9285 4.99991C18.2263 3.78374 17.2164 2.77383 16.0002 2.0717C14.784 1.36956 13.4044 0.999946 12 1C10.5957 1.00005 9.21615 1.36977 8 2.072",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99997 9L1.21997 8.375L0.719971 9L1.21997 9.625L1.99997 9ZM11 10C11.2652 10 11.5195 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5195 8.10536 11.2652 8 11 8V10ZM5.21997 3.375L1.21997 8.375L2.77997 9.625L6.77997 4.625L5.21997 3.375ZM1.21997 9.625L5.21997 14.625L6.77997 13.375L2.77997 8.375L1.21997 9.625ZM1.99997 10H11V8H1.99997V10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.00b488cfdb15cd72d8f7761cb4d9d10a.svg";
export { ForwardRef as ReactComponent };